<template>
  <section v-if="value" class="relative inline-flex items-center">
    <slot />
    <span
      :class="[
        'absolute rounded-full flex items-center justify-center z-9',
        bgColor,
        left,
        right,
        top,
        textColor,
        borderClass,
        sizeClass,
        textSize,
      ]"
    >
      {{ value }}
    </span>
  </section>

  <template v-else>
    <slot />
  </template>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  const props = defineProps({
    value: {
      type: [String, Number],
      default: null,
    },
    bgColor: {
      type: String,
      default: "bg-primary-800",
    },
    textColor: {
      type: String,
      default: "text-white",
    },
    borderColor: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: "sm",
    },
    right: {
      type: String,
      default: "-right-3",
    },
    left: {
      type: String,
      default: "",
    },
    top: {
      type: String,
      default: "-top-3",
    },
    textSize: {
      type: String,
      default: "text-xs",
    },
  });

  const borderClass = computed(() => (props.borderColor ? `border ${props.borderColor}` : ""));

  const sizeClass = computed(() => {
    switch (props.size) {
      case "sm":
        return "w-[20px] h-[20px]";
      case "md":
        return "";
      case "lg":
        return "";
      default:
        return "w-[20px] h-[20px]";
    }
  });
</script>

<style scoped></style>
